<template>
  <div class="mit-reservation-activity-list pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <v-card flat>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn small v-on="on" class="ma-2" @click="resetDialog">Add Filter</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add Filter</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select :items="filterableHeaders" :hint="filterItem.hint" :persistent-hint="true" item-text="text" item-value="value" label="Name" required v-model="filterItem" return-object @change="changedFilter"></v-select>
                  <v-text-field label="Value" required v-model="filterValue"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="addFilter">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <BaseMitUrlParams ref="mitUrlParamsRef" v-on:changed="updateFilters"/>
    </v-card>
    <!-- <MitReservationActivityList :reservationActivity="activity" showDetails/> -->
    <BaseMitDataTable
      title="Activity"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :editable="false"
      :headers="headers"
      :items="activity"
      :showExpanded="true" 
      itemKey="id"
      :singleExpanded="false"
      @pagination="updatePagination"
    >
        <template v-slot:expanded-item="{ item }">
            <!-- expand across all the columns, so use the header length -->
            <td class="pa-1" :colspan="headers.length+1">
              <BaseMitReservationReadOnly :reservation="item.data" showDetails/>
            </td>
        </template>
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';
import MitActivityApiService from '../../../base/services/BaseMitReserveActivityApiService.js';

import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
import BaseMitReservationReadOnly from '../../../base/components/reserve/BaseMitReservationReadOnly.vue';

export default {
  name: 'MitReservationActivity',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams,
    BaseMitReservationReadOnly
  },
  props: {
  },
  data: function() {
    return {
      dialog:false,
      filterItem:null,
      filterValue:'',
      loading:false,
      search: '',
      options:{},
      paging:{
        page:1,
        pageSize:5,
        totalItems:0
      },
      filterableHeaders:[ //moment().local().format("hh:mm A")
        {text: 'CSAIL ID',value: 'userId', default:'', hint:'The exact csail id'},
        {text: 'User Role',value: 'userRole', default:'', hint:'The exact userRole'},
        {text: 'Space',value: 'mitId', default:'', hint:'The exact space id'},
        {text: 'Type',value: 'type', default:'', hint:'The exact type "created", "updated", "deleted" or "reverted"'},
        {text: 'Id',value: 'id', default:'', hint:'The exact id of the activity'},
        {text: 'Unique Id',value: 'uniqueId', default:'', hint:'The exact unique id of the reservation'},
        {text: 'Unique Id Series',value: 'recurringUniqueId', default:'', hint:'Enter the recurring unique id, will display edits users made to individual events in this recurring series'},
        {text: 'Start Date',value: 'startDt', default:MitActivityApiService.getActivityDateStringLocal(), hint:'Create Date >=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
        {text: 'End Date',value: 'endDt', default:MitActivityApiService.getActivityDateStringLocal(), hint:'End Date <=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
      ],
      headers:[
          {text: 'Id',sortable: true,value: 'id'},
          {text: 'Type',sortable: true,value: 'type'},
          {text: 'Reservation ID',sortable: true,value: 'uniqueId'},
          {text: 'Space',sortable: false,value: 'data.mitId'},
          {text: 'Changed By User',sortable: true,value: 'userId'},
          {text: 'User Role',sortable: true,value: 'userRole'},
          {text: 'Date',sortable: true,value: 'createDt'}
        ],
      activity:[]
    }
  },
  created() {
    this.resetDialog();
  },
  methods : {
    updatePagination (pagination) {
      //setting this into the control will trigger this event so initiall don't bother refreshing
      //if the items length is zero, we have no data yet.
      if(pagination.itemsLength > 0){
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.refreshData(this.paging, this.options);
      }

    },
    updateFilters(options){
      this.options = options;
      this.paging.page = 1;//we changed the filter so start over with a new data set
      this.refreshData(this.paging, this.options);
    },
    refreshData(pagination, options){
      this.loading = true;
      MitActivityApiService.requestGetActivity(pagination, options)
        .then((data) => {
          this.loading = false;

          this.activity = data.activity;
          this.paging.totalItems = data.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    resetDialog(){
      this.filterItem = this.filterableHeaders[5];
      this.filterValue = null;
    },
    changedFilter(item){
      this.filterValue = item.default;
    },
    addFilter(){
      if(MitActivityApiService.isActivityDateTimeValid(this.filterValue)){
        this.filterValue = MitActivityApiService.getActivityDateStringUtc(this.filterValue);
      }

      this.$refs.mitUrlParamsRef.add(this.filterItem.value, this.filterValue);
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
